<script setup lang="ts">
</script>

<template>
  <div class="flex items-end gap-2 animate-fade-in">
    <!-- Avatar -->
    <img
      src="/emily-avatar.jpg"
      alt="Emily"
      class="flex-shrink-0 w-8 h-8 rounded-full object-cover"
    />

    <!-- Typing bubble -->
    <div class="bg-white rounded-2xl rounded-bl-md px-4 py-3 shadow-sm border border-gray-100">
      <div class="flex gap-1">
        <span class="typing-dot"></span>
        <span class="typing-dot"></span>
        <span class="typing-dot"></span>
      </div>
    </div>
  </div>
</template>
